import request from '@/plugins/axios'

// oauth登录
export function oauthLoginApi(provider_name, data) {
  return request({
    url: `/authentication/openid_provider/${provider_name}/login`,
    method: "post",
    data,
  });
}
// 获取认证服务地址
export function authUrlApi(provider_name) {
  return request({
    url: `/authentication/openid_provider/${provider_name}`,
  });
}
